import React, {useEffect, useMemo, useState, Suspense, lazy} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {connect} from'react-redux'

import Button from 'js/components/shared/Button';
import ModuleByKey from '../../components/ModuleByKey';
import {searchBox} from '../../drupalSettings';
import {
  MODULE_DESTINATION,
  MODULE_ROOMS,
  MODULE_DATES,
} from '../../constants'
import {convertDatesToString, convertRoomsToString, prepareDates} from '../../helpers';

import styles from './SearchViewPreview.module.scss';

const ModuleDropdown = lazy(() => import('../../components/ModuleDropdown'));

const cx = classnames.bind(styles);
const wordings = searchBox?.titles;

const convertModuleToTitle = {
  [MODULE_DESTINATION]: (data) => data,
  [MODULE_ROOMS]: (rooms) => convertRoomsToString(rooms),
  [MODULE_DATES]: (dates) => convertDatesToString(dates, 'DD MMMM YYYY') || wordings?.selectDates,
}

const convertModuleToSubtitle = {
  [MODULE_DESTINATION]: (data) => data,
  [MODULE_ROOMS]: (rooms) => convertRoomsToString(rooms),
  [MODULE_DATES]: (dates) => convertDatesToString(dates, 'DD MMM') || wordings?.selectDates,
}

const getInfoByKey = function (key, data, schema) {
  return key in schema ? schema[key](data[key]) : key;
}

const SearchViewPreview = function ({
  className,
  modules,
  onSubmit,
  onReset,
  onModuleChange,
  activeFilter,
  loading,
  displaySubmit = true,
  titleInfo = [MODULE_DATES],
  subtitleInfo = [MODULE_ROOMS],
  queryData,
}) {
  const [isOpen, toggleIsOpen] = useState(false)

  const onModalClose = () => {
    toggleIsOpen(false);
  };

  const openEditButtonClick = () => {
    toggleIsOpen(true);
  };

  const onSubmitSearchForm = async () => {
    const resp = await onSubmit();

    if (resp?.success && !resp?.redirect) {
      toggleIsOpen(false);
    }
  };

  const getTitleInfo = useMemo(function () {
    return titleInfo.map(key => getInfoByKey(key, queryData, convertModuleToTitle)).join('');
  }, [titleInfo, queryData]);

  const getSubtitleInfo = useMemo(function () {
    return subtitleInfo.map(key => getInfoByKey(key, queryData, convertModuleToSubtitle)).join('');
  }, [subtitleInfo, queryData]);

  const onResetBtnClick = function () {
    toggleIsOpen(false);
    onReset();
  };

  useEffect(() => {
    if (!isOpen && activeFilter) {
      toggleIsOpen(true);
    }
  }, [activeFilter]);

  return (
    <>
      <div className={cx('root', className)}>
        <div className={cx('info-wrap')}>
          {getTitleInfo && (<p className={cx('info', 'highlighted')}>{getTitleInfo}</p>)}
          {getSubtitleInfo && (<p className={cx('info')}>{getSubtitleInfo}</p>)}
        </div>
        <div className={cx('actions')}>
          <Button
            type="button"
            theme="link"
            onClick={openEditButtonClick}
            className={cx('edit-btn')}
          >{wordings.edit}</Button>
        </div>
      </div>
      {isOpen && (
        <Suspense>
          <ModuleDropdown
          title=""
          submitTxt={wordings.searchButtonValue}
          onClose={onModalClose}
          submitLoading={loading}
          onSubmit={displaySubmit ? onSubmitSearchForm : null}
          isModalView
        >
          <div className={cx('modules-wrap')}>
            {modules.map((module, i) => (
              <ModuleByKey
                info={module}
                key={i}
                onChange={onModuleChange}
                className={cx('module')}
              />
            ))}
            <div className={cx('reset-btn-wrap')}>
              <Button
                className={cx('reset-btn')}
                theme="link"
                onClick={onResetBtnClick}
              >{wordings.resetFilters}</Button>
            </div>
          </div>
        </ModuleDropdown>
        </Suspense>
      )}
    </>
  )
}

SearchViewPreview.propTypes = {
  data: PropTypes.any
}

export default connect(({main, searchBox, url}) => ({
  activeFilter: searchBox?.activeFilter,
  queryData: {
    dates: prepareDates({
      dateIn: url?.parameters?.dateIn,
      nbNight: url?.parameters?.nbNight,
    }),
    rooms: url?.parameters?.apartment,
    destination: url?.parameters?.q || '',
  },
}))(SearchViewPreview);
